<template>
    <v-container class="py-10">
        <!-- Logo -->
        <v-img max-height="150" max-width="200" src="./Bilgros.png" class="mx-auto mb-6" contain />

        <!-- Header -->
        <div class="text-center mb-10">
            <h1 class="text-h4 font-weight-bold">Support Client</h1>
            <p class="text-subtitle-1 text-grey-darken-1">
                Retrouvez les réponses aux questions fréquentes ou proposez la vôtre.
            </p>
        </div>

        <!-- FAQ Section -->
        <v-expansion-panels multiple class="mb-12">
            <v-expansion-panel v-for="(item, index) in faq" :key="index">
                <v-expansion-panel-title>{{ item.question }}</v-expansion-panel-title>
                <v-expansion-panel-text>{{ item.answer }}</v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>

        <!-- Ask a Question Form -->
        <v-card class="pa-6 rounded-xl elevation-3">
            <h2 class="text-h6 font-weight-bold mb-4">Proposer une question</h2>

            <v-form ref="form" v-model="valid" lazy-validation>
                <!-- Nom -->
                <v-text-field v-model="form.name" label="Votre nom" prepend-icon="mdi-account" outlined
                    :rules="[rules.required]" class="mb-4" />

                <!-- Email -->
                <v-text-field v-model="form.email" label="Votre email" prepend-icon="mdi-email" type="email" outlined
                    :rules="[rules.required, rules.email]" class="mb-4" />

                <!-- Question -->
                <v-textarea id="Comment" v-model="form.question" label="Votre question" :rules="[rules.required]"
                    variant="outlined" rows="3" prepend-icon="mdi-help-circle"></v-textarea>

                <!-- Bouton -->
                <div class="text-center mt-6">
                    <v-btn color="primary" rounded size="large" class="px-8" :disabled="!valid" @click="submitForm">
                        Envoyer
                    </v-btn>
                </div>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "SupportClient",
    data() {
        return {
            valid: false,
            form: {
                name: "",
                email: "",
                question: "",
            },
            rules: {
                required: (v) => !!v || "Ce champ est requis",
                email: (v) => /.+@.+\..+/.test(v) || "Veuillez entrer un email valide",
            },
            faq: [
                {
                    question: "Comment créer un compte ?",
                    answer: "Téléchargez l’application et suivez les étapes d’inscription.",
                },
                {
                    question: "Comment réinitialiser mon mot de passe ?",
                    answer: "Cliquez sur « Mot de passe oublié » sur l’écran de connexion.",
                },
                {
                    question: "Comment contacter le support ?",
                    answer: "Vous pouvez utiliser ce formulaire ou nous écrire directement.",
                },
            ],
        };
    },
    methods: {
        submitForm() {
            if (this.valid) {
                alert("Merci ! Votre question a été enregistrée ✅");
                this.form = { name: "", email: "", question: "" };
            }
        },
    },
};
</script>
